// @flow

import { map, noop } from 'lodash/fp';

import createReducer from '../utils/createReducer';
import switchFunc from '../utils/switchFunc';
import { API_CALL_FAILURE, API_CALL_SUCCESS, API_CALL_REQUEST } from '../constants/actionTypes';
import {
  TRAINER_COMPLETED_CHALLENGES,
  TRAINER_LIVE_CHALLENGES,
  TRAINER_UPCOMING_CHALLENGES
} from '../constants/apiTypes';
import decodeChallenge from '../normalizers/decodeChallenge';

const mapChallenges = map(decodeChallenge);

const initialState = {
  completedChallenges: [],
  completedInitialised: false,
  errors: [],
  liveChallenges: [],
  liveInitialised: false,
  upcomingChallenges: [],
  upcomingInitialised: false
};

const apiRequestReducer = switchFunc(
  {
    [API_CALL_REQUEST]: () => ({
      errors: []
    })
  },
  () => noop
);

const apiSuccessReducer = switchFunc(
  {
    [TRAINER_COMPLETED_CHALLENGES]: (state, action) => ({
      completedChallenges: mapChallenges(action.data, action.meta),
      completedInitialised: true
    }),
    [TRAINER_LIVE_CHALLENGES]: (state, action) => ({
      liveChallenges: mapChallenges(action.data, action.meta),
      liveInitialised: true
    }),
    [TRAINER_UPCOMING_CHALLENGES]: (state, action) => ({
      upcomingChallenges: mapChallenges(action.data, action.meta),
      upcomingInitialised: true
    })
  },
  () => noop
);

const apiFailureReducer = switchFunc(
  {
    [API_CALL_FAILURE]: (state, action) => ({
      errors: action.errors
    })
  },
  () => noop
);

export default createReducer(initialState, {
  [API_CALL_REQUEST]: (state, action) => apiRequestReducer(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiSuccessReducer(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiFailureReducer(action.api)(state, action)
});
